const notifications = {
  paymentError: "Payment failed",
  paymentSuccess: "Successful payment",
  paymentAlreadyDone: "Payment already completed",
  alreadySubscribed: "You are already subscribed",
  passwordChanged: "Password successfully updated!",
  errorChangingPassword: "Error changing password!",
  invalidOldPassword: "The current password is incorrect.",
  passwordConfirmationDontMatch:
    "The new password and confirmation do not match.",
  emailExists:
    "This email is already associated with an active iizenglish account.",
  validationMailResent: "Confirmation email resent!",
  signupError:
    "An error occurred while creating your account. Please contact an administrator.",
  loginError:
    "An error occurred during login. Please contact the application administrator.",
  loginNotAllowed: "Login from this interface is not allowed.",
  errorCheckEmail: "An error occurred. Please check your email address.",
  errorValidatingEmail:
    "An error occurred while validating your email address.",
  setPasswordError:
    "An error occurred while creating your password. Please contact the application administrator.",
  mailValidated: "Email address validated, you can now log in!",
  mailValidationTokenNotFound: "This validation link is no longer valid.",
  emailOrPasswordWrong: "The email address and/or password is incorrect.",
  forgotPasswordError: "Error while requesting a password reset!",
  tokenExpired: "Token expired!",
  tokenExpiredText:
    "Your request for a new password has expired. Please submit a new request.",
  badLink: "This link is invalid!",
  anErrorOccurred: "An error occurred",
  checkCSV: "Please check your CSV file.",
  ifDontUnderstandImportError:
    "If you don't understand where the error comes from, please send your CSV file along with the content below to the development team.",
  bugs: {
    reportSuccess:
      "Bug report sent successfully. Thank you for your contribution.",
    reportFailure: "An error occurred, please try again later.",
    serviceUnavailable:
      "The bug reporter is currently unavailable, please try again later after reloading the page",
  },
  class: {
    creationSuccess: "Class saved.",
    creationFailure: "An error occurred while creating the item.",
    creationFailure400: "Class could not be saved. Please fix the errors.",
    creationFailure409:
      "Class could not be saved - it already exists in this school.",
    editionFailure: "Error while updating the class.",
    editionFailure400: "Class could not be saved. Please fix the errors.",
    getClassesError:
      "An error occurred while loading the classes. Please contact the application administrator.",
    getClassError:
      "An error occurred while loading the class. Please contact the application administrator.",
    teacherAlreadyInClassError: "You are already a teacher of this class!",
    teacherJoinsClassSuccess:
      'You are now a teacher of this class. Access it from the "My classes" menu.',
    deletionSuccess: "The class has been successfully deleted.",
    deletionFailure:
      "An error occurred while deleting the class. Please contact the application administrator.",
    tooFewLinesInClass: "The class must contain at least one student.",
  },
  schools: {
    getSchoolsError:
      "An error occurred while loading the schools. Please contact the application administrator.",
    getSchoolError:
      "An error occurred while loading the school. Please contact  the application administrator.",
    purgeSuccess: "Data successfully cleared!",
    purgeError:
      "An error occurred while purging the selected schools. Please contact an administrator.",
    updateSchoolError: "An error occurred while updating school",
    updateSchoolSuccess: "School updated successfully",
    createSchoolSuccess: "School created successfully",
    createSchoolError: "An error occurred while creating the school",
    createSchoolAlreadyExistError: "This school already exists.",
  },
  students: {
    getStudentsError:
      "An error occurred while loading the students. Please contact the application administrator.",
    getStudentError:
      "An error occurred while loading the student. Please contact the application administrator.",
    missingPasswordForActivation:
      "A password is required to activate the account.",
    createStudentSuccess: "Student created successfully",
    updateStudentSuccess: "Student updated successfully",
    createStudentError: "An error occurred while creating the student",
    updateStudentError: "An error occured while updating the student",
    deleteStudentSuccess: "Student successfully removed from the class.",
    studentUnauthorizedToAccessHomework:
      "You are not allowed to access this assignment.",
  },
  blogs: {
    getBlogsError:
      "An error occurred while loading the blog posts. Please contact the application administrator.",
    getBlogError:
      "An error occurred while loading the blog post. Please contact the application administrator.",
    getBlogImageError:
      "An error occurred while loading the images for the blog. Please contact an administrator.",
  },
  countries: {
    getCountriesError:
      "An error occurred while loading the countries. Please contact the application administrator.",
    getCountryError:
      "An error occurred while loading the country. Please contact an administrator.",
    updateCountrySuccess: "Country updated successfully.",
    createCountrySuccess: "Country created successfully.",
    updateCountryError: "An error occurred while updating the country.",
    createCountryError: "An error occured while creating the country.",
  },
  homework: {
    creationSuccess: "Assignment saved successfully.",
    creationFailure: "An error occurred while creating the assignment. ",
    updateSuccess: "Assignment updated successfully.",
    updateFailure: "An error occurred while updating the assignment. ",
    checkSubscriptionFailure:
      "An error occurred while loading the assignment creation page. Please contact the application administrator.",
    expired: "The due date has passed.",
    alreadyStarted:
      "Cannot change the publication status: at least one student has already started this assignement.",
    cannotDeletePublishedHomework: "Published assignments cannot be deleted.",
    cannotUpdatePublishedHomework: "Published assignments cannot be edited.",
    getHomeworkError:
      "An error occurred while loading the assignment. Please contact the application administrator.",
    retrieveHomeworksError:
      "An error occurred while loading your assignments. Please contact the application administrator.",
    saveHomeworkError:
      "An error occurred while saving your assignment. Please contact the application administrator.",
    deleteHomeworkSuccess: "Assignment deleted successfully.",
    deleteHomeworkError:
      "An error occurred while deleting the assignment. Please contact the application administrator.",
    endTimer:
      "Your assignment will end in one minute. Please submit your answers.",
    noExerciseInHomework:
      "This assignment currently contains no exercises. Please contact your teacher.",
    gradeUnfinishedHomeworkSuccess:
      "Incomplete assignments have been graded successfully. The data has been updated.",
    mismatchedHomeworkData:
      "This assignment has already been completed and graded. You can redo it if it is still open.",
  },
  exercise: {
    saveSuccess: "Exercise saved successfully.",
    saveFailure: "An error occurred while saving the exercise.",
    getExercisesContentsError:
      "An error occurred while loading the exercise contents. Please contact the application administrator.",
    getExercisesError:
      "An error occurred while loading the exercises. Please contact the application administrator.",
    getExerciseError:
      "An error occurred while loading the exercise. Please contact the application administrator.",
    getExerciseNotFound:
      "The exercise does not exist or is not available. Please contact the application administrator.",
    incompleteExercise: "The exercise is incomplete.",
  },
  blog: {
    saveSuccess: "Blog post saved successfully.",
    saveFailure: "An error occurred while saving the blog post.",
    imageFailure:
      "The image is too large. Please choose a smaller image (maximum size: 1 MB).",
    updateSuccess: "Blog post updated.",
    updateFailure: "An error occurred while updating the blog post. ",
    deleteSuccess: "Blog post deleted successfully.",
    deleteFailure: "An error occurred while deleting the blog post.",
    completedInAllLanguages:
      "The title, keywords and description fields must be completed in all languages.",
  },
  user: {
    loginTimeout: "Your session has expired",
    editionSuccess: "Your profile has been saved",
    editionFailure: "An error occurred while saving your profile. ",
    deleteSuccess:
      "Your account has been deleted successfully. See you soon on iizenglish!",
    loadingDataError: "An error occured while initializing your session",
    sessionLost: "Your session has expired. Please log in again to continue.",
  },
  account: {
    deleteSuccess: "The account has been deleted successfully.",
    deleteFailure: "An error occurred while deleting the account.",
    accountActivated: "Account activated",
    accountNotActivated: "Account not activated",
    accountDoesNotExists: "No account is associated with this email address.",
    pendingAccountExists:
      "An account with this email is already pending verification.",
  },
  garSubscriptions: {
    getSubscripionsError: "An error occurred while loading GAR subscriptions.",
    getSubscripionError: "An error occurred while loading the GAR subscription",
    getEstablishmentsError: "An error occurred while loading GAR schools",
    createSubscripionError: "An error occurred while creating the subscription",
    createSubscripionSuccess: "GAR subscription created successfully !",
    updateSubscripionError: "An error occurred while updating the subscription",
    updateSubscripionSuccess: "GAR subscription updated successfully !",
    deleteSubscripionSuccess:
      "The subscription has been deleted successfully .",
    deleteSubscripionError:
      "An error occurred while deleting the subscription.",
  },
  teachers: {
    getTeacherStudentsError: "An error occurred while loading your students.",
    getTeacherSchoolsError: "An error occurred while loading your schools.",
    retrieveTeachersError:
      "An error occurred while loading teachers. Please contact the application administrator.",
    updateTeacherSuccess: "Teacher updated successfully",
    updateTeacherEmailError:
      "The email address is already in use. The teacher could not be updated",
    updateTeacherPasswordError: "A password is required for activation.",
    createTeacherSuccess: "Teacher created successfully",
    createTeacherError: "An error occurred while creating the teacher",
    createTeacherPasswordError:
      "A password is required to activate the account.",
    createTeacherEmailError:
      "The email address is already in use. The teacher could not be created.",
    setGradingSystemError:
      "An error occurred while saving your preferences. If the problem persists, please contact an administrator.",
    setGradingSystemSuccess: "Your grading system has been saved successfully.",
  },
  fieldsError: "Some fields contain errors.",
  sendReminderSuccess: "Reminder sent",
  sendReminderError:
    "An error occurred while sending the reminder. Please contact the application administrator.",
  emptyAnswer: "The answer field is empty.",
  emptyAnswerRemaining: "At least one answer field is still empty.",
  incompleteHomework: "The assignment is incomplete.",
  noAnswerSelected: "No answer selected.",
  noAnswerMoved: "No answers moved.",
  clickAgainToValidate: "Click the button again if you still want to submit.",
  clickAgainToGoBack:
    "You have unsaved changes. Click the Back button again if you want to leave without saving.",
  clickAgainToGoToExercise:
    "Click the button again if you still want to switch exercises. Unsaved data will be lost.",
  clickAgainToFinish:
    "Click the button again if you still want to finish the assignment.",
  tableofcontentResetSuccess: "Contents reset!",
  tableofcontentResetError: "An error occurred while resetting the contents.",
  errorOccuredUpdating:
    "An error occurred while updating the information. Please contact an administrator.",
  resources: {
    getResourcesError:
      "An error occurred while loading the resources. Please contact an administrator.",
    updateDescriptionError:
      "An error occurred while updating the description. Please contact an administrator.",
  },
  messageDontMatch: "The message does not match",
  twoFactorAuth: {
    incorrectCode: "Invalide code.",
    expiredCode: "The verification code has expired. Please request a new one.",
    validationError: "An error occured. Please try again.",
    newRequestSent: "We’ve sent a new verification code to your email.",
  },
  missingStudentsLevelPart1:
    "Some students in this assignment do not have a level set. Click the button again",
  missingStudentsLevelPart2: "to continue.",
  subscriptions: {
    updateHideReminderError:
      "An error occurred while updating your subscription settings. Please contact an administrator.",
  },
  mockExams: {
    importSuccess: "Mock tests imported successfully !",
    importError: "An error occurred during the import.",
    getMockExamsTableOfContentsError:
      "An error occurred while loading the mock test overview. Please contact the application administrator.",
    getMockExamError:
      "An error occurred while loading the mock test. Please contact the application administrator.",
  },
  globalParameters: {
    updateValueError:
      "An error occurred while updating the setting. Please contact the application administrator.",
    updateValueSuccess: "The setting was updated successfully.",
    resetValueSuccess: "The setting was reset successfully.",
    listError:
      "An error occurred while retrieving the settings. Please contact the application administrator.",
    simplifiedListError:
      "An error occurred while loading the application. Please try again later or contact the application administrator.",
  },
};

export default notifications;
